import {purchaseBreakPreview,validatePurchaseCommercial} from './purchaseBreakState';
export const cloneOperations = value => {const next=JSON.parse(JSON.stringify(value||{}));if(next.purchase)next.laser=false;return next;};
export function sameOperationDraft(left,right) {
  const canonical=value=>Array.isArray(value)?value.map(canonical):value&&typeof value==='object'
    ?Object.fromEntries(Object.keys(value).sort().map(key=>[key,canonical(value[key])])):value;
  return JSON.stringify(canonical(cloneOperations(left)))===JSON.stringify(canonical(cloneOperations(right)));
}
export function operationEnabled(ops,key) {
  if(key==='laser')return ops.laser!==false;
  if(key==='bend')return !!ops.bending?.enabled;
  if(key==='etch')return ops.engraving_length_mm!=null;
  if(key==='deburr')return !!ops.deburr;
  if(key.startsWith('secondary:'))return (ops.secondary||[]).some(x=>x.process_id===key.slice(10));
  return !!ops[key];
}
export function toggleOperation(ops,key,enabled,defaults=null) {
  const next=cloneOperations(ops),saved={...(next.disabled_values||{})};
  if(key==='laser')next.laser=enabled;
  else if(key==='bend')next.bending={...(next.bending||defaults||{}),enabled};
  else if(key==='deburr')next.deburr=enabled;
  else if(key.startsWith('secondary:')) {
    const id=key.slice(10),items=next.secondary||[],current=items.find(x=>x.process_id===id);
    if(enabled){next.secondary=current?items:[...items,(saved.secondary||[]).find(x=>x.process_id===id)||defaults];saved.secondary=(saved.secondary||[]).filter(x=>x.process_id!==id);}
    else {if(current)saved.secondary=[...(saved.secondary||[]).filter(x=>x.process_id!==id),current];next.secondary=items.filter(x=>x.process_id!==id);}
  } else {
    const field=key==='etch'?'engraving_length_mm':key;
    if(enabled){next[field]=next[field]??saved[key]??defaults;delete saved[key];}
    else {if(next[field]!=null)saved[key]=next[field];next[field]=null;}
  }
  // V1 Xv canonical purchase dispatch excludes laser; turning purchase off
  // does not invent a restoration of the prior laser state.
  if(next.purchase)next.laser=false;
  next.disabled_values=saved;return next;
}
export function secondaryDefaults(def,line) {
  return {process_id:def.id,value:def.basis==='area_m2'?line.width_mm*line.length_mm/1000000:def.basis==='throughput'?1:['per_part','quote_value'].includes(def.basis)?1:.1,unit_value_micros:def.basis==='quote_value'?0:null,finish:''};
}
export function operationInputInvalid(ops,processes=[],quantity=1) {
  if(ops.deburr&&ops.deburr_sell_each_cents!=null&&(!Number.isSafeInteger(ops.deburr_sell_each_cents)||ops.deburr_sell_each_cents<0||!Number.isSafeInteger(ops.deburr_sell_each_cents*quantity)))return true;
  try {purchaseBreakPreview(ops.purchase,quantity);validatePurchaseCommercial(ops.purchase,ops.laser!==false);}catch{return true;}
  if(ops.bending?.enabled&&(!(ops.bending.bends_per_part>=1)||!(ops.bending.longest_fold_mm>0)))return true;
  if(ops.engraving_length_mm!=null&&!(ops.engraving_length_mm>0))return true;
  return (ops.secondary||[]).some(item=>{const def=processes.find(x=>x.id===item.process_id);return def?.basis==='quote_value'&&(!(item.unit_value_micros>0)||!(item.value>0))||def?.basis==='throughput'&&!(item.value>0);});
}
